











import { Component, Vue, Prop } from "vue-property-decorator";
import { SubProjectModel } from "../models/subProject";
import { GListOption } from "shared/global/types";
import dateflip from "shared/filters/dateflip";

@Component
export default class SubProjectInfo extends Vue {
  @Prop({ required: true, type: Object }) private value!: SubProjectModel;

  t(key: string): string {
    return this.$t("houseprojects.subProjectInfo." + key).toString();
  }

  private filterOptions(options: GListOption[]): GListOption[] {
    return options.filter((option) => {
      return option.value !== "";
    });
  }

  get renterData(): GListOption[] {
    if (this.value.renter_data === undefined) return [];
    const rd = this.value.renter_data;
    const res: GListOption[] = [
      {
        label: this.t("name"),
        value: rd.relation_name,
      },
    ];
    if (!rd.person) {
      return res;
    }

    res.push(
      {
        label: this.t("age"),
        value: rd.age > 0 ? String(rd.age) + " jaar" : "",
      },
      {
        label: this.t("birthPlace"),
        value: rd.birth_place,
      },
      {
        label: this.t("nationality"),
        value: rd.nationality,
      },
      {
        label: this.t("maritalStatus"),
        value: rd.marital_status,
      }
    );

    return this.filterOptions(res);
  }

  get incomeData(): GListOption[] {
    if (
      this.value.income_data === undefined ||
      this.value.renter_data === undefined ||
      !this.value.renter_data.person
    )
      return [];

    const id = this.value.income_data;

    const res = [
      {
        label: this.t("incomeSource"),
        value: id.income_source,
      },
      {
        label: this.t("laborContract"),
        value: id.labor_contract,
      },
      {
        label: this.t("function"),
        value: id.function,
      },
      {
        label: this.t("brutoIncome"),
        value: id.bruto_income,
      },
    ];

    return this.filterOptions(res);
  }

  get leaseAgreement(): GListOption[] {
    const res: GListOption[] = [
      {
        label: this.t("type"),
        value: this.value.type,
      },
    ];

    if (this.value.lease_agreement === undefined) return res;

    const la = this.value.lease_agreement;

    res.push(
      {
        label: this.t("startLease"),
        value: dateflip(la.start_lease),
      },
      {
        label: this.t("endLease"),
        value: dateflip(la.end_lease),
      },
      {
        label: this.t("cancelableAfter"),
        value: dateflip(la.cancelable_after),
      },
      {
        label: this.t("cancellationPeriod"),
        value: la.cancellation_period,
      }
    );

    return this.filterOptions(res);
  }
}
